import { GETTER_TYPES } from './_getter-types';

export const getters = {
	[GETTER_TYPES.CAMPAIGN_IDENTIFIER](state) {
		return state.campaignIdentifier;
	},
	[GETTER_TYPES.CAMPAIGN](state) {
		return state.campaign;
	},
	[GETTER_TYPES.CATEGORIES](state) {
		return state.categories;
	},
	[GETTER_TYPES.BRANDS](state) {
		return state.selectedCategory;
	},
	[GETTER_TYPES.GET_SELECTED_BRAND](state) {
		return state.selectedBrand;
	},
	[GETTER_TYPES.GET_SELECTED_MODEL](state) {
		return state.selectedModel;
	},
	[GETTER_TYPES.GET_SELECTED_COLOR](state) {
		return state.selectedColor;
	},
	[GETTER_TYPES.GET_SELECTED_CATEGORY](state) {
		return state.selectedCategory;
	},
	[GETTER_TYPES.LOADING_CATEGORIES](state) {
		return state.loadingCategories;
	},
	[GETTER_TYPES.LOADING_BRANDS](state) {
		return state.loadingBrands;
	},
	[GETTER_TYPES.LOADING_COLORS](state) {
		return state.loadingColors;
	},
	[GETTER_TYPES.GENDERS](state) {
		return state.genders;
	},
	[GETTER_TYPES.STATES](state) {
		return state.states;
	},
	[GETTER_TYPES.CONTRACT_FORM](state) {
		return state.contractForm;
	},
	[GETTER_TYPES.QUALITIES](state) {
		return state.qualities;
	},
	[GETTER_TYPES.QUALITY_TYPES](state) {
		return state.qualityTypes;
	},
	[GETTER_TYPES.SELECTED_QUALITY](state) {
		return state.selectedQuality;
	},
	[GETTER_TYPES.APPRAISAL](state) {
		return state.appraisal;
	},
	[GETTER_TYPES.USER_BUYOUT_CODE](state) {
		return state.userBuyoutCode;
	},
	[GETTER_TYPES.CAN_NOT_BE_BUYOUT](state) {
		return state.canNotBeBuyout;
	},
	[GETTER_TYPES.DISPLAY_THANK_YOU](state) {
		return state.displayThankYou;
	},
	[GETTER_TYPES.IS_APPRAISAL_EDITABLE](state) {
		return state.isAppraisalEditable;
	},
	[GETTER_TYPES.APPRAISAL_ERRORS](state) {
		return state.appraisalErrors;
	},
	[GETTER_TYPES.APPRAISAL_RESULTS](state) {
		return state.appraisalResults;
	},
	[GETTER_TYPES.APPRAISAL_LOAD_ERROR](state) {
		return state.appraisalLoadError;
	},
	[GETTER_TYPES.DEFAULT_QUALITY_CONDITIONS](state) {
		return state.defaultQualityConditions;
	},
	[GETTER_TYPES.BUYOUT_BONUSES](state) {
		return state.buyoutBonuses;
	},
	[GETTER_TYPES.IS_PRE_SALE_INFO](state) {
		return state.isPreSaleInfo;
	},
	[GETTER_TYPES.IS_BUYOUT_ONLINE](state) {
		return state.isBuyoutOnline;
	},
	[GETTER_TYPES.PRESALE_INFO_EMAIL](state) {
		return state.preSaleInfoEmail;
	},
	[GETTER_TYPES.BUYOUT_LOAD_ERROR](state) {
		return state.buyoutLoadError;
	},
	[GETTER_TYPES.BUYOUT_STATE](state) {
		return state.buyoutState;
	},
	[GETTER_TYPES.IS_REGISTRATION](state) {
		return state.isRegistration;
	},
	[GETTER_TYPES.IS_LOGGED_IN](state) {
		return state.isLoggedIn;
	},
	[GETTER_TYPES.BONUS_TYPE](state) {
		return (state.campaign && state.campaign.bonus_type) || null;
	},
	[GETTER_TYPES.SELECTED_BONUS](state) {
		return state.selectedBonus;
	},
	[GETTER_TYPES.BUYOUT_STATE_IDENTIFIER](state) {
		return state.buyoutStateIdentifier;
	},
	[GETTER_TYPES.IS_BUYOUT_EDITABLE](state) {
		if (!state.buyoutStateIdentifier) return true;

		let type = state.stateTypes.find(
			type => type.identifier === state.buyoutStateIdentifier
		);

		return type && type.is_editable;
	},
	[GETTER_TYPES.BUYOUT_RECEIPT](state) {
		return state.buyoutReceipt;
	},
	[GETTER_TYPES.BUYOUT_RECEIPT_ERRORS](state) {
		return state.buyoutReceiptErrors;
	},
	[GETTER_TYPES.PICKUP_ADDRESS](state) {
		return state.pickupAddress;
	},
	[GETTER_TYPES.PICKUP_ADDRESS_ERRORS](state) {
		return state.pickupAddressErrors;
	},
	[GETTER_TYPES.NEW_DEVICE_IMEI](state) {
		return state.newDeviceImei;
	},
	[GETTER_TYPES.NEW_DEVICE_IMEI_ERRORS](state) {
		return state.newDeviceImeiErrors;
	},
	[GETTER_TYPES.NEW_DEVICE_IMEI_SAVED](state) {
		return state.newDeviceImeiSaved;
	},
	[GETTER_TYPES.EDITABLE_IMEI](state) {
		return state.editableImei;
	},
	[GETTER_TYPES.DISABLE_BUYOUT_SEND_BTN](state) {
		return state.disableBuyoutSendBtn;
	},
	[GETTER_TYPES.STATE_TYPES](state) {
		return state.stateTypes;
	},
	[GETTER_TYPES.COMMON_ERROR](state) {
		return state.commonError;
	},
	[GETTER_TYPES.PARTNERS](state) {
		return state.partners;
	},
	[GETTER_TYPES.SELECTED_PARTNER](state) {
		return state.selectedPartner;
	},
	[GETTER_TYPES.CONSENT_TO_MARKETING](state) {
		return state.consentToMarketing;
	},
	[GETTER_TYPES.USABLE_BUYOUT_BONUSES](state) {
		if (state.isRegistration) return state.campaign.buyout_bonuses;
		return [state.selectedBonus];
	},
	[GETTER_TYPES.TOTAL_STEPS](state) {
		if (
			(state.campaign &&
				state.campaign.buyout_bonuses &&
				state.campaign?.buyout_bonuses?.length > 0) ||
			state.selectedBonus
		) {
			return 3;
		}
		return 2;
	},
	[GETTER_TYPES.GET_BUYOUT_PAYLOAD](state){
		let deviceForm = state.appraisalResults.filter(item=>item).map(item => item.value);
		if (!deviceForm.length > 0) deviceForm = state.appraisal.appraisal_result[0].default_device_condition_choices;
		let deviceQualities = state.appraisal.device_conditions
			.filter(cond => cond.type === 'quality')
			.map(cond => cond.choices[0]);

		deviceQualities.forEach(deviceQuality => {
			if (state.selectedQuality.id === deviceQuality.appraisal_result)
				deviceForm.push(deviceQuality.value);
		});

		let buyout_device = state.contractForm.buyout_device;

		if ('new_device_imei' in buyout_device)
			delete buyout_device['new_device_imei'];

		return {
			user_buyout_code: '',
			appraisal_version: state.appraisal.version,
			device_identifier: state.selectedColor.seo_name,
			device_type: state.selectedCategory.seo_name,
			note: buyout_device.note,
			device_condition_choices: deviceForm,
			buyout_device: buyout_device,
			customer_data: state.contractForm.customer_data,
			partner: state.selectedNewModelPartner ? state.selectedNewModelPartner:state.selectedPartner,
			consent_to_marketing: state.consentToMarketing
		}
	},
	[GETTER_TYPES.GET_IS_DIFFERENT_PICKUP_ADDRESS](state) {
		return state.isDifferentPickupAddress;
	},
	[GETTER_TYPES.GET_SELECTED_NEW_MODEL](state){
		return state.selectedNewModel;
	},
	[GETTER_TYPES.GET_SELECTED_NEW_MODEL_PARTNER](state){
		return state.selectedNewModelPartner;
	},
	[GETTER_TYPES.GET_BUYOUT_APPRAISAL_RESULT_BY_ID](state) {
		return Object.fromEntries(
      state.appraisal?.appraisal_result.map(r => [r.id, r]) ?? []
    );
	},
	[GETTER_TYPES.GET_TOTAL_PRICE_CORRECTION](state) {
		return state.appraisalResults.filter(item => item).reduce((accumulator, object) => accumulator + object.price_correction, 0);
	}
}
